import styled from 'styled-components';
import { motion } from 'framer-motion';

const TitleWrapper = styled(motion.h1)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 48px;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
  z-index: -1;
  text-align: center;
  pointer-events: none;
  cursor: auto;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Title = () => {
  return (
    <TitleWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      🎈 Estoure a Bolha da IA 🎈
    </TitleWrapper>
  );
};
